import React from 'react';
import {
  DashboardOutlined,
  BookOutlined,
  SettingOutlined,
  LogoutOutlined,
  HistoryOutlined,
  ClusterOutlined,
} from '@ant-design/icons';

export interface NavigationItem {
  key: string;
  icon: React.ReactNode;
  labelKey: string;
  path?: string;
  action?: 'logout';
}

export const primaryNavigationItems: NavigationItem[] = [
  {
    key: '/demo',
    icon: <DashboardOutlined />,
    labelKey: 'navigation.demo',
    path: '/demo',
  },
  {
    key: '/guides',
    icon: <BookOutlined />,
    labelKey: 'navigation.guides',
    path: '/guides',
  },
  {
    key: '/usage',
    icon: <HistoryOutlined />,
    labelKey: 'navigation.usage',
    path: '/usage',
  },
  {
    key: '/clusters',
    icon: <ClusterOutlined />,
    labelKey: 'navigation.clusters',
    path: '/clusters',
  },
];

export const secondaryNavigationItems: NavigationItem[] = [
  {
    key: '/settings',
    icon: <SettingOutlined />,
    labelKey: 'navigation.settings',
    path: '/settings',
  },
  {
    key: 'logout',
    icon: <LogoutOutlined />,
    labelKey: 'navigation.logout',
    action: 'logout',
  },
];

export interface BreadcrumbRoute {
  path: string;
  labelKey: string;
}

export const breadcrumbRoutes: BreadcrumbRoute[] = [
  { path: '/demo', labelKey: 'navigation.demo' },
  { path: '/guides', labelKey: 'navigation.guides' },
  { path: '/usage', labelKey: 'navigation.usage' },
  { path: '/clusters', labelKey: 'navigation.clusters' },
  { path: '/settings', labelKey: 'navigation.settings' },
];